export default {
    baseApiUrl: 'http://localhost:1323/v1',
};
